import { render } from "./RequestedVideos.vue?vue&type=template&id=69b52e5c&scoped=true"
import script from "./RequestedVideos.vue?vue&type=script&lang=js"
export * from "./RequestedVideos.vue?vue&type=script&lang=js"

import "./RequestedVideos.vue?vue&type=style&index=0&id=69b52e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b52e5c"]])

export default __exports__